<template>
  <div>
    <EmailGrabberPopup
      @close="toggleGrabber"
      :grabberActive="grabberActive"
      :freePlan="freePlan"
      :payPlan="payPlan"
      :planId="planId"
      class="overflow-y-hidden"
    >
    </EmailGrabberPopup>
    <section
      class="mx-[25px] mt-[50px] content-center rounded-[19px] rounded-b-none bg-[#EDFAFE] md:rounded-t-[60px] lg:mx-auto lg:flex xl:h-[1000px] xl:w-[1300px]"
    >
      <div class="py-10 px-[25px] lg:mx-auto lg:flex-col lg:pt-[110px]">
        <!-- TABS -->
        <div
          class="font-bold flex text-[#292d34] text-xs lg:text-lg mx-auto max-w-[550px] text-center justify-between"
        >
          <div class="w-full">
            <h3
              class="cursor-pointer"
              v-on:click="toggleTabs(1)"
              v-bind:class="{
                'hover:ease-in': openTab !== 1,
                '': openTab === 1
              }"
            >
              Member Portal
            </h3>

            <hr
              class="mt-[10px] h-[5px] lg:w-[130px] rounded-full bg-[#49CCF9] mx-auto"
              v-bind:class="{
                'hidden ': openTab !== 1,
                'block ease-in-out duration-700': openTab === 1
              }"
            />
          </div>

          <div class="w-full px-auto">
            <h3
              class="cursor-pointer"
              v-on:click="toggleTabs(2)"
              v-bind:class="{ '': openTab !== 2, '': openTab === 2 }"
            >
              Live Stream
            </h3>
            <hr
              class="mt-[10px] h-[5px] lg:w-[120px] rounded-full bg-[#49CCF9] mx-auto"
              v-bind:class="{
                'hidden hover:block': openTab !== 2,
                'block ease-in-out duration-700': openTab === 2
              }"
            />
          </div>

          <div class="w-full">
            <h3
              class="cursor-pointer"
              v-on:click="toggleTabs(3)"
              v-bind:class="{ '': openTab !== 3, '': openTab === 3 }"
            >
              Video Calls
            </h3>
            <hr
              class="mt-[10px] h-[5px] lg:w-[110px] rounded-full bg-[#49CCF9] mx-auto"
              v-bind:class="{
                'hidden hover:block': openTab !== 3,
                'block ease-in-out duration-700': openTab === 3
              }"
            />
          </div>
        </div>

        <!-- TABS END -->

        <h2
          class="top-full mt-[20px] px-0 text-center text-[35px] font-bold text-[#292d34] sm:text-[40px] lg:text-[45px] lg:leading-[69px] xl:text-[50px]"
          v-bind:class="{
            'hidden ': openTab !== 1,
            'block ease-in-out duration-700': openTab === 1
          }"
        >
          The world’s most powerful<br />
          (and profitable) member’s portal.
        </h2>
        <h2
          class="top-full mt-[20px] px-0 text-center text-[35px] font-bold text-[#292d34] sm:text-[40px] lg:text-[45px] lg:leading-[69px] xl:text-[50px]"
          v-bind:class="{
            'hidden hover:block': openTab !== 2,
            'block ease-in-out duration-700': openTab === 2
          }"
        >
          Bring the community to life<br />
          with live streaming webinars.
        </h2>
        <h2
          class="top-full mt-[20px] px-0 text-center text-[35px] font-bold text-[#292d34] sm:text-[40px] lg:text-[45px] lg:leading-[69px] xl:text-[50px]"
          v-bind:class="{
            'hidden hover:block': openTab !== 3,
            'block ease-in-out duration-700': openTab === 3
          }"
        >
          Coach in real time with<br />
          1-on-1 video calls.
        </h2>

        <div
          class="z-30 mt-[25px] xl:mt-10"
          v-bind:class="{
            'hidden ': openTab !== 1,
            'block ease-in-out duration-700': openTab === 1
          }"
        >
          <video
            class="lg:w-[860px] rounded-[10px] lg:rounded-[20px] shadow-2xl"
            id="home_video"
            loop
            muted
            autoplay
            playsinline
          >
            <source
              :src="$filters.media_path('/videos/member-login-com.mp4')"
              type="video/mp4"
            />
          </video>
        </div>
        <div
          class="z-30 mt-[25px] xl:mt-10"
          v-bind:class="{
            'hidden hover:block': openTab !== 2,
            'block ease-in-out duration-700': openTab === 2
          }"
        >
          <img
            loading="lazy"
            class="w-[860px]"
            :src="
              $filters.media_path(
                '/images/live-streaming-to-members-in-course-members-area.png'
              )
            "
            alt="Best way to monetize social media by moving followers OFF social media."
          />
        </div>
        <div
          class="z-30 mt-[25px] xl:mt-10"
          v-bind:class="{
            'hidden hover:block': openTab !== 3,
            'block ease-in-out duration-700': openTab === 3
          }"
        >
          <video
            class="lg:w-[860px] rounded-[10px] lg:rounded-[20px] shadow-2xl"
            id="home_video"
            loop
            muted
            autoplay
            playsinline
          >
            <source
              :src="
                $filters.media_path(
                  '/videos/video-call-meetings-in-your-online-course-com.mp4'
                )
              "
              type="video/mp4"
            />
          </video>
        </div>
      </div>
    </section>

    <div
      class="mx-[25px] h-[63px] rounded-[19px] rounded-t-none bg-[#49cdf92a] pt-[11px] text-center md:rounded-b-[60px] lg:mx-auto xl:w-[1300px]"
    >
      <div
        class="mx-auto my-0 flex h-[42px] w-[142px] justify-center rounded-[9px] bg-transparent align-middle hover:ease-in-out hover:duration-500 hover:bg-white"
      >
        <!-- class="bg-[url('/img/arrow-right-blue.svg')] text-sm font-semibold text-[#292d34]" -->
        <button
          @click="toggleGrabber('free', null)"
          type="button"
          class="text-sm font-semibold text-[#292d34]"
        >
          Get Started
        </button>

        <img
          :src="$filters.media_path('/images/arrow-right-blue.svg')"
          alt=""
          class="ml-2 w-[17px]"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'turquoise-sectio'
};
</script>

<script setup>
import { ref } from 'vue';
import EmailGrabberPopup from '../Components/EmailGrabberPopup.vue';

const openTab = ref(1);
const grabberActive = ref(false);
const freePlan = ref(false);
const payPlan = ref(false);
const planId = ref(null);
const toggleTabs = (tabNumber) => {
  openTab.value = tabNumber;
};

const toggleGrabber = (plan, id) => {
  if (plan === 'free') {
    freePlan.value = true;
    payPlan.value = false;
    planId.value = null;
  }
  if (plan === 'pay') {
    payPlan.value = true;
    planId.value = id;
    freePlan.value = false;
  }
  grabberActive.value = !grabberActive.value;
};
</script>

<styles>
</styles>
